<template>
  <div id="burger-container">
    <input id="burger" type="checkbox" @click="toggleMobileNav" />
    <label for="burger">
      <span></span>
      <span></span>
      <span></span>
    </label>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'Hamburger',
  methods: {
    ...mapActions(['toggleMobileNav'])
  }
}
</script>

<style lang="scss" scoped>
#burger-container {
  position: relative;
}

input + label {
  position: absolute;
  left: 0px;
  top: 0px;
  height: 25px;
  width: 20px;
  z-index: 5;
  background-color: #fff;
  span {
    position: absolute;
    width: 100%;
    height: 2px;
    top: 50%;
    margin-top: -1px;
    left: 0;
    display: block;
    background: #2d2d2d;
    transition: .5s;
  }
  span:first-child {
    top: 5px;
  }
  span:last-child {
    top: 21px;
  }
}
label:hover {
  cursor: pointer;
}
input:checked + label {
  span {
    opacity: 0;
    top: 50%;
  }
  span:first-child {
    opacity: 1;
    transform: rotate(45deg);
  }
  span:last-child {
    opacity: 1;
    transform: rotate(-45deg);
  }
}
input ~ nav {
  background: white;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100px;
  z-index: 3;
  transition: .3s;
  transition-delay: .3s;
  overflow: hidden;
  > ul {
    text-align: center;
    position: absolute;
    top: 35%;
    left: 20%;
    right: 20%;
    > li {
      opacity: 0;
      transition: .3s;
      transition-delay: 0s;
      > a {
        text-decoration: none;
        text-transform: uppercase;
        color: white;
        font-weight: 700;
        font-family: sans-serif;
        display: block;
        padding: 30px;
      }
    }
  }
}
input:checked ~ nav {
  height: 100%;
  transition-delay: 0s;
  > ul {
    > li {
      opacity: 1;
      transition-delay: .5s;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/app/components/Icons/Hamburger.vue?f7ed6a3a